import React, { useState, useEffect } from "react";
import { TextField } from "@material-ui/core";
import "./LineTypeSettings.css";

export default function LineTypeOther({ LineType, UpdateLineType }) {
  const [lineType, setLineType] = useState(LineType);

  const handleUpdate = (event, key, value) => {
    LineType[key] = event ? event.target.value : value;
    UpdateLineType(LineType);
  };
  const handleChange = (event, key, value) => {
    setLineType({
      ...LineType,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLineType(LineType);
  }, [LineType, setLineType]);

  return (
    <React.Fragment>
      <div className="vertical-options">
        <h3>Odds Increment Rate</h3>
        <TextField
          size="small"
          type="number"
          label="Football / Basketball"
          value={lineType.nbaIncrease}
          onChange={(event) => handleChange(event, "nbaIncrease")}
          onBlur={(event) => handleUpdate(event, "nbaIncrease")}
          variant="outlined"
        />
        <TextField
          size="small"
          type="number"
          label="Baseball"
          value={lineType.mlbIncrease}
          onChange={(event) => handleChange(event, "mlbIncrease")}
          onBlur={(event) => handleUpdate(event, "mlbIncrease")}
          variant="outlined"
        />
        <TextField
          size="small"
          type="number"
          label="Hockey"
          value={lineType.nhlIncrease}
          onChange={(event) => handleChange(event, "nhlIncrease")}
          onBlur={(event) => handleUpdate(event, "nhlIncrease")}
          variant="outlined"
        />
      </div>
    </React.Fragment>
  );
}
